// Login APIs

/**
 * @function ApiClient#Login
 * @this {ApiClient}
 * @param {any} username
 * @param {any} password
 * @param {any} options = {}
 */
export async function Login(username, password, options = {}) {
  // Get token first
  const tokenData = await this._get("/community/token", options);

  // Import sha256 library
  const sha256 = require("js-sha256").sha256;

  // Prepare login payload
  const loginPayload = {
    user: username,
    token: tokenData.Token,
    digest: sha256(`${username}:${tokenData.Token}:${password}`),
  };

  // Perform login
  return await this._post("/community/login", loginPayload, options);
}
